module.exports = __webpack_public_path__ + "img/part2.ba4da766.png";